import { render, staticRenderFns } from "./ToolbarNew.vue?vue&type=template&id=06aad213"
import script from "./ToolbarNew.vue?vue&type=script&lang=js"
export * from "./ToolbarNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06aad213')) {
      api.createRecord('06aad213', component.options)
    } else {
      api.reload('06aad213', component.options)
    }
    module.hot.accept("./ToolbarNew.vue?vue&type=template&id=06aad213", function () {
      api.rerender('06aad213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/ToolbarNew.vue"
export default component.exports